(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ChatMessageDialogController', ChatMessageDialogController);

    ChatMessageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'ChatMessage', 'Chat'];

    function ChatMessageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, ChatMessage, Chat) {
        var vm = this;

        vm.chatMessage = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.chats = Chat.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.chatMessage.id !== null) {
                ChatMessage.update(vm.chatMessage, onSaveSuccess, onSaveError);
            } else {
                ChatMessage.save(vm.chatMessage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:chatMessageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
